import { defineStore } from 'pinia';
import { deleteGoods as deleteGoodsApi, downGoods as downGoodsApi, getGoodsList, getHotGoodsDesc, getTagList, setGoods, setHotGoods as setHotGoodsApi, upGoods as upGoodsApi } from '@/api/seller/product';

interface FilterState {
  goods_sn: string
  tag_id: string
  is_pass: string
  lock_lv: string
  is_on_sale: string
  is_xiugai: string
  is_like_goods_sn: string
}

interface ProductListState {
  tags: API.TagItem[]
  checked: number[]
  tips: string[]
  usedNumber: string
  filter: FilterState
}

export const useProductList = defineStore({
  id: 'seller-product-list',
  state: (): ProductListState => ({
    tags: [],
    checked: [],
    tips: [],
    usedNumber: '',
    filter: {
      goods_sn: '',
      tag_id: '',
      is_pass: '',
      lock_lv: '',
      is_on_sale: '',
      is_xiugai: '',
      is_like_goods_sn: '1',
    },
  }),
  getters: {},
  actions: {
    async getProductsList(page: number, pageSize: number, filter: Record<string, any>) {
      return getGoodsList({
        ...filter,
        page,
        limit: pageSize.toString(),
      }).then((res: any) => {
        const list = (res?.data || []).map((item: any) => ({
          ...item,
        }));
        this.checked = [];
        this.getHotGoodsDesc();
        return { list, total: res?.total || 0 };
      });
    },
    async getTags() {
      const data = await getTagList();
      this.tags = data;
    },
    async getHotGoodsDesc() {
      try {
        const data = await getHotGoodsDesc();
        this.tips = data.list;
        this.usedNumber = `(${data.use_num}/${data.max_num})`;
      }
      catch {
        // ignore
      }
    },
    clearChecked() {
      this.checked = [];
    },
    async upGoods(data: API.UpGoodsParam) {
      return upGoodsApi(data);
    },
    async downGoods(data: API.DownGoodsParam) {
      return downGoodsApi(data);
    },
    async deleteGoods(data: API.DeleteGoodsParam) {
      return deleteGoodsApi(data);
    },
    async setHotGoods(data: API.SetHotParam) {
      return setHotGoodsApi(data);
    },
    async setGoods(data: API.SetGoodsParam) {
      return setGoods(data);
    },
  },
});
